import { render, staticRenderFns } from "./CV.vue?vue&type=template&id=7669240a&"
import script from "./CV.vue?vue&type=script&lang=ts&"
export * from "./CV.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports